import { useEffect, useState } from 'react';
import { useAnimalHeaven } from '../../context/animalHeaven.provider';
import { setGifToShow } from '../../context/animalHeaven.actions';

const loadedGifs: { [key: string]: string } = {};

const Gif = () => {
  const { animalHeavenDispatch, gifToShow } = useAnimalHeaven();
  const [showGif, setShowGif] = useState<boolean>(false);

  useEffect(() => {
    const handleGif = async () => {
      if (loadedGifs[gifToShow]) {
        setShowGif(true);
      } else {
        const file = await import(`../../assets/gifs/${gifToShow}.gif`);
        loadedGifs[gifToShow] = file.default;
        setShowGif(true);
      }
    };

    gifToShow && handleGif();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gifToShow]);

  useEffect(() => {
    if (showGif) {
      const timerId = setTimeout(() => {
        animalHeavenDispatch(setGifToShow({ gifName: '' }));
        setShowGif(false);
      }, 4000);

      return () => clearTimeout(timerId);
    }
  }, [animalHeavenDispatch, showGif]);

  return (
    <>
      {showGif && (
        <div className="absolute z-30 flex h-full w-full items-center justify-center bg-black bg-opacity-40">
          <img src={loadedGifs[gifToShow]} alt="" className="max-w-[100%]" />
        </div>
      )}
    </>
  );
};

export default Gif;
